module.exports = __webpack_public_path__ + "static/media/Sugar's Functions gif script_1607437530237.d2c99312.docx";